import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderClaimForm, setOrderClaimForm } from 'domains/order/Order.store';
import { getTextMandatory, isHidden } from 'pages/MyOrdersPage/OrderClaims/claimForm.utils';
import { makeKey, RULES_DATA } from 'pages/MyOrdersPage/OrderClaims/claimFormRulesData';
import { Flex, Input, Text } from 'UI';

const ContactSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const claimForm = useSelector(getOrderClaimForm);
  const rulesData =
    RULES_DATA[makeKey({ formType: claimForm.formType, reason: claimForm.reason, option: claimForm.option })];

  const allSectionFields = [
    rulesData?.contact,
    rulesData?.email,
    rulesData?.phoneNumber,
    rulesData?.pickupAddress,
    rulesData?.pickupTimeSlots,
  ];

  const isContactSectionHidden = allSectionFields.every((field) => isHidden(field));

  if (isContactSectionHidden) {
    return null;
  }

  return (
    <>
      <Text type="heading3" disableGutter noWrap>
        {t('order.claim.contact_section', 'Who will be our contact in your Dealership?')}
      </Text>
      <Flex gap={30}>
        {!isHidden(rulesData?.contact) && (
          <Flex direction={'column'} maxWidth={200}>
            <Text type="base" noWrap>
              {getTextMandatory(t('common.contact', 'Contact'), rulesData?.contact)}
            </Text>
            <Input
              name={'claim_contact'}
              bordered
              initialValue={claimForm.contact}
              onChangeDebounced={(contact: string) => dispatch(setOrderClaimForm({ ...claimForm, contact }))}
            />
          </Flex>
        )}
        {!isHidden(rulesData?.email) && (
          <Flex direction={'column'} maxWidth={200}>
            <Text type="base" noWrap>
              {getTextMandatory(t('common.email', 'E-mail address'), rulesData?.email)}
            </Text>
            <Input
              name={'claim_contact_email'}
              bordered
              initialValue={claimForm.email}
              onChangeDebounced={(email: string) => dispatch(setOrderClaimForm({ ...claimForm, email }))}
            />
          </Flex>
        )}
        {!isHidden(rulesData?.phoneNumber) && (
          <Flex direction={'column'} maxWidth={200}>
            <Text type="base" noWrap>
              {getTextMandatory(t('common.phone_number', 'Phone number'), rulesData?.phoneNumber)}
            </Text>
            <Input
              name={'claim_contact_phone'}
              bordered
              initialValue={claimForm.phoneNumber}
              onChangeDebounced={(phoneNumber: string) =>
                dispatch(
                  setOrderClaimForm({
                    ...claimForm,
                    phoneNumber,
                  }),
                )
              }
            />
          </Flex>
        )}
      </Flex>
      <Flex gap={30}>
        {!isHidden(rulesData?.pickupAddress) && (
          <Flex direction={'column'} maxWidth={300}>
            <Text type="base" noWrap>
              {getTextMandatory(
                t('order.claim.pickup_address', 'Address to pickup the return'),
                rulesData?.pickupAddress,
              )}
            </Text>
            <Input
              name={'claim_contact_address'}
              bordered
              initialValue={claimForm.pickupAddress}
              onChangeDebounced={(pickupAddress: string) =>
                dispatch(setOrderClaimForm({ ...claimForm, pickupAddress }))
              }
            />
          </Flex>
        )}
        {!isHidden(rulesData?.pickupTimeSlots) && (
          <Flex direction={'column'} maxWidth={300}>
            <Text type="base" noWrap>
              {getTextMandatory(t('order.claim.pickup_time_slots', 'When can we stop by?'), rulesData?.pickupTimeSlots)}
            </Text>
            <Input
              name={'claim_contact_stop_by_time'}
              bordered
              initialValue={claimForm.pickupTimeSlots}
              onChangeDebounced={(pickupTimeSlots: string) =>
                dispatch(setOrderClaimForm({ ...claimForm, pickupTimeSlots }))
              }
            />
          </Flex>
        )}
      </Flex>
    </>
  );
};

export default ContactSection;
